import { Heading2, MicroText, SmallText } from '@sb1/ffe-core-react';
import Image from '../../../components/image/Image';
import { getSimpleCollectedText, isProjectADugnad } from '../../project-model';
import { useMemo } from 'react';
import { getSubprojectTitle } from '../../subproject-model';
import VerificationBadge from '../../../components/verification-badge/VerificationBadge';
import styles from './payment-compact-info-card.module.less';
import { Link } from 'react-router';
import { formatOrganizationNumber } from '../../../utils';

const ReceiverInfo = ({ project, showOrgNumber }) => {
    if (project?.receiverInformation?.isInvited) {
        return <SmallText className={styles.clampTwoLines}>Pengene går til en invitert mottaker</SmallText>;
    } else if (project?.receiverInformation?.name) {
        const displayOrgNumber = showOrgNumber && project?.receiverInformation?.organizationNumber;
        return (
            <>
                <div>
                    <SmallText className={styles.clampTwoLines}>
                        Pengene går til{' '}
                        {project?.receiverInformation?.showVerifiedBadge && (
                            <VerificationBadge
                                verified={project?.receiverInformation?.isVerified}
                                className={styles.badge}
                            />
                        )}
                        <span className={styles.receiverName}>{project?.receiverInformation?.name}</span>
                    </SmallText>
                    {displayOrgNumber && (
                        <SmallText className={styles.orgNumber}>
                            Org. nr: {formatOrganizationNumber(project?.receiverInformation?.organizationNumber)}
                        </SmallText>
                    )}
                </div>
            </>
        );
    }
};

export const PaymentCompactInfoCard = ({ project, subproject, dismissSupport, showOrgNumber }) => {
    const pathToProject = () => {
        return `/project/${project?.id}${subproject?.id ? `?subproject=${subproject.id}` : ``}`;
    };

    const isDugnad = isProjectADugnad(project);
    const title = useMemo(() => {
        const dugnadTitle = getSubprojectTitle({ subproject, isDugnad });
        return dugnadTitle || project?.title || '';
    }, [subproject?.anonymous, subproject?.name, isDugnad, project?.title]);

    const imageUrl = project?.img_url;

    return (
        <Link className={styles.card} onClick={dismissSupport} aria-label={'Gå til spleisen'} to={pathToProject()}>
            {imageUrl && (
                <div className={styles.imageContainer}>
                    <Image src={imageUrl} alt={project?.title} className={styles.image} />
                </div>
            )}
            <div className={styles.projectInfo}>
                <Heading2 className={styles.projectInfoTitle} lookLike={6} noMargin>
                    {title}
                </Heading2>
                <MicroText strong className={styles.collectedAmount}>
                    {getSimpleCollectedText(project)}
                </MicroText>
                <ReceiverInfo project={project} showOrgNumber={showOrgNumber} />
            </div>
        </Link>
    );
};
